import { sanitizeObject } from './sanitize.helper';

/**
 * It takes a path and a set of query parameters, and returns a path with the query parameters appended
 * to it
 * @param {string} path - The path of the URL.
 * @param params - Record<string, string>
 * @returns A function that takes a path and params and returns a string.
 */
export const getPathWithQueryParams = (
    path: string,
    params: Record<string, string>,
): string => {
    const sanitizeParams = sanitizeObject(params);
    if (Object.keys(sanitizeParams).length) {
        const queryString = new URLSearchParams(sanitizeParams).toString();
        return `${path}?${queryString}`;
    }
    return path;
};
